import { Input } from "antd";
import React from "react";
import { FaRegEnvelope } from "react-icons/fa6";
import { Button } from "../Button/Button";

const WeeklyNewLetter = ({ data }) => {
  return (
    <>
      <div
        className="d-flex flex-column gap-4 align-items-center justify-content-center h-100 p-md-4 p-3 rounded-4"
        style={{ background: "#242535" }}
      >
        <div className="d-flex flex-column gap-2 text-center">
          <h3 className="text-white fs-5 fw-medium">{data?.fields?.heading}</h3>
          <span className="fw-light fs-6" style={{ color: "#97989F" }}>
            {data?.fields?.desclaimer}
          </span>
        </div>

        <div className="d-flex flex-column gap-1 w-100 px-4">
          {data?.fields?.fields?.map((fieldData, idx) => (
            <React.Fragment key={idx}>
              <Input
                style={{ background: "#181A2A" }}
                className="rounded-2 py-2 px-3 news-letter-input "
                placeholder={fieldData?.placeholder}
                type={fieldData?.type}
                suffix={<FaRegEnvelope size={18} />}
              />
            </React.Fragment>
          ))}
          {data?.fields?.CTAs?.map((buttonData, idx) => (
            <React.Fragment key={idx}>
              <Button
                textColor={buttonData?.textColor}
                background={buttonData?.backgroundColor}
                className={"px-5 py-2"}
              >
                {buttonData?.text}
              </Button>
            </React.Fragment>
          ))}
        </div>
      </div>
    </>
  );
};

export default WeeklyNewLetter;
